import UI from "~/ui";
import $ from "jquery";
import { getApi } from "~/auth";

export async function IsVenditaSeguita(userInfo : any, lottoId: number): Promise<void> {
    if (userInfo?.isAuthenticated && userInfo?.anagraficaId) {
        try {
            const isSeguita = await GetVenditaSeguita(userInfo?.anagraficaId, lottoId);
            if (isSeguita) {
                $("#seguiVendita").addClass("d-none");
                $("#venditaSeguita").removeClass("d-none");
            }

        } catch (error) {
            console.error("Errore durante il controllo della vendita seguita:", error);
            UI.confirmOneButton("", "Errore durante il controllo della vendita seguita"); //TODO: i18n
        }
    }
}

export async function GetVenditaSeguita(anagraficaId: number, lottoId: number): Promise<boolean> {
    const auth = getApi();
    const url = `${window.BaseUrlWebApi}VenditaSeguita/IsVenditaSeguita?lottoId=${lottoId}&anagraficaId=${anagraficaId}`;

    try {
        const data = await auth.fetchWithAuth("GET " + url, {
            cache: "no-cache",
            headers: { 'content-type': 'application/json' },
        });
        return data;
    } catch (error) {
        console.error("Errore GetVenditaSeguita:", error);
        throw error;
    }
}

export async function AddVenditaSeguita(anagraficaId: number, lottoId: number): Promise<number> {
    const auth = getApi();
    const url = `${window.BaseUrlWebApi}VenditaSeguita/Insert`;

    try {
        const data = await auth.fetchWithAuth("POST " + url, {
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                AnagraficaId: anagraficaId,
                LottoId: lottoId
            }),
        });
        return data;
    } catch (error) {
        console.error("Errore AddVenditaSeguita:", error);
        throw error;
    }
}

export async function RemoveVenditaSeguita(anagraficaId: number, lottoId: number): Promise<any> {
    const auth = getApi();
    const url = `${window.BaseUrlWebApi}VenditaSeguita/DeleteByLottoIdAndAnagraficaId?lottoId=${lottoId}&anagraficaId=${anagraficaId}`;

    try {
        const data = await auth.fetchWithAuth("DELETE " + url, {
            cache: "no-cache",
            headers: { 'content-type': 'application/json' },
        });
        return data;
    } catch (error) {
        console.error("Errore RemoveVenditaSeguita:", error);
        throw error;
    }
}